
import images from "../images/images";

function ProfileStat({ icon, value, maxValue, label }) {
  return (
    <div className="profile-stat">
      <img src={images[icon]} className="profile-stat-icon" alt={label} />
      <div className="profile-stat-info">
       
      <div className="profile-stat-value">
        {value} </div>
        <span className="profile-stat-max">/{maxValue}</span>
        </div>
      <div className="profile-stat-label">{label}</div>
    </div>
  );
}

export  {ProfileStat};